import { Directive, OnInit, Input, ElementRef } from '@angular/core';
import { AutorizacionService } from '../../seguridad/autorizacion.service';


@Directive({
  selector: '[accessOptionDirective]'
})

export class AccessOptionDirective implements OnInit {
  @Input() accessOptionDirective: string;

  constructor(
    private el: ElementRef,
    private autorizacionService: AutorizacionService
  ) {}

  ngOnInit(): void {
    this.determineVisibility();
  }

  determineVisibility() {
    try {
      if (this.autorizacionService.authorize(this.accessOptionDirective)) {
        this.makeVisible();
      } else {
        this.makeHidden();
      }
    } catch (e) {
      this.makeHidden();
    }
  }

  makeVisible(): void {
    this.el.nativeElement.classList.remove('d-none');
  }

  makeHidden(): void {
    this.el.nativeElement.classList.add('d-none');
  }
}
